import { connect } from "react-redux";
import { selectRankingFilterLanguageSettings } from "../../balancingSelectors/selectBalancingLanguage";
import { selectCoopSelectedLanguage } from "../../selectors/selectCoopInfo";
import { DialogLanguageFilter, } from "../generic/menu-language-filter/DialogLanguageFilter";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopJoinableCoopList, actionCoopSetFilterLanguageSelected, actionCoopSetFoundLanguageSelected, } from "./actionCoop";
import { IdCoopCategory } from "./IdCoopCategory";
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopLanguageFilter)); },
    onConfirm: function (filterLanguage, tabId) {
        if (tabId && tabId === IdCoopCategory.CoopSearch) {
            dispatch(actionCoopSetFilterLanguageSelected(filterLanguage));
            dispatch(actionCoopJoinableCoopList({
                language: filterLanguage.languageCode,
                playerId: undefined,
            }));
        }
        else {
            dispatch(actionCoopSetFoundLanguageSelected(filterLanguage));
        }
        dispatch(actionModalClose(IdModal.CoopLanguageFilter));
    },
}); };
var mapState = function (state) { return ({
    languageSettings: selectRankingFilterLanguageSettings(),
    selectedFilterLanguage: selectCoopSelectedLanguage(state),
}); };
export var DialogCoopLanguageFilter = connect(mapState, mapDispatch)(DialogLanguageFilter);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogCoopLanguageFilter.tsx
// module id = 2560
// module chunks = 3